<template>
  <div class="navbar-container">
    <div class="nav-left">
      <span
        class="iconify nav-text"
        data-icon="ion-logo-apple"
        data-inline="false"
        style="font-size: 20px"
      ></span>
      <div class="nav-text bold"><span class="desktop-app-title">{{ $store.getters.activeWindow }}</span><span class="mobile-app-title">{{ mobileAppTitle }}</span></div>
      <div class="nav-text hidden-small">File</div>
      <div class="nav-text hidden-small">Edit</div>
      <div class="nav-text hidden-small">View</div>
      <div class="nav-text hidden-small">Go</div>
      <div class="nav-text hidden-small">Window</div>
      <div class="nav-text hidden-small">Help</div>
    </div>
    <div class="nav-right">
      <!-- <button @click="toggleTheme" class="theme-toggle">
        {{ theme === "light" ? "🌙 Dark Mode" : "☀️ Light Mode" }}
      </button> -->
      <div class="date text-right">
        <span>{{ this.date }}</span>
      </div>
      <div class="time text-right">
        <!-- 11:22PM -->
        <span>{{ this.time }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      time: "",
      date: "",
    };
  },

  computed: {
    mobileAppTitle() {
      const activeWindow = this.$store.getters.activeWindow;
      return activeWindow === "Desktop" ? "Finder" : activeWindow;
    },
    theme() {
      return this.$store.getters.theme;
    },
  },
  methods: {
    toggleTheme() {
      this.$store.commit("toggleTheme");
    },
  },
  beforeMount() {
    setInterval(() => {
      this.time = moment().format("h:mmA"); // Time format remains the same
    }, 1000);
    setInterval(() => {
      this.date = moment().format("ddd MMM D"); // Changed to 'day month date'
    }, 1000);
  },
};
</script>

<style scoped>
.navbar-container {
  width: 100%;
  height: 25px;
  padding-top: 5px;
  padding-bottom: 5px;
  background-color: rgba(29, 26, 26, 0.2);
  backdrop-filter: blur(25px);
  display: flex;
  align-items: center;
  justify-content: space-between;

  /* position: absolute; 
  top: 0;
  left: 0;
  z-index: 9999; */
}

.nav-left {
  display: flex;
  width: auto;
  margin-left: 15px;
  align-items: center;
}

.iconify {
  margin-right: 5px;
}

.nav-text {
  font-size: 14px;
  font-weight: 600;
  margin-left: 10px;
  margin-right: 10px;
  color: white;
}

.nav-right {
  display: flex;
  width: auto;
  justify-content: space-evenly;
  margin-right: 12px;
  color: white;
}

.text-right {
  font-size: 14px;
  font-weight: 600;
  margin-left: 7px;
  margin-right: 7px;
}

.bold {
  font-weight: 1000;
}

.mobile-app-title { display: none; }

@media only screen and (max-width: 600px) {
  .desktop-app-title { display: none; }
  .mobile-app-title { display: inline; }
  .hidden-small {
    display: none;
  }
  .nav-left {
    width: 150px;
    margin-left: 5px;
  }
  .nav-right {
    margin-right: 5px;
  }
  .text-right {
    margin-right: 5px;
    margin-left: 5px;
  }
  .nav-text {
    margin-right: 5px;
    margin-left: 5px;
  }
}

.theme-toggle {
  background: none;
  border: none;
  font-size: 14px;
  cursor: pointer;
  margin-right: 10px;
}
</style>
